/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { Button, Grid } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import StyledTextField from "../common/StyledTextField";
import BaseButton from "../common/BaseButton";
import CarrierFilter from "../../components/filters/CarrierFilter";
import UserTypeFilter from "../user-management/UserTypeFilter";

import { fetchCarriers } from "../../slices/carriersSlice";
import {
  updateUserManagementFilters,
  resetUserManagementFilters,
} from "../../slices/userManagementFiltersSlice";

const StyledWrapperGridItem = styled(Grid)`
  background-color: ${(props) => props.theme.palette.background.lightGrey};
  flex: 0 0 auto !important;
  padding: 16px;
  .MuiFormControl-marginDense {
    margin-bottom: 0;
    margin-top: 0;
  }
`;

const StyledFilterGridItem = styled(Grid)`
  padding-right: 0 !important;
`;

const StyledGridHeaderItem = styled(Grid)`
  flex: 0 0 100%;
`;

const StyledButton = styled(({ theme, ...props }) => <Button {...props} />)`
  color: ${(props) => props.theme.palette.link.main} !important;
  text-decoration: underline !important;
`;

const UserManagementFiltersContainer = () => {
  const filters = useSelector((state) => state.userManagementFilters);
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [searchTerm, setSearchTerm] = useState(null);
  const [carrierId, setCarrierId] = useState(null);

  const theme = useTheme();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCarriers());
  }, []);

  useEffect(() => {
    setSearchTerm(filters.searchTerm);
    setCarrierId(filters.carrierId);
    setSelectedUserType(filters.roleId);
  }, []);

  const handleResetFilters = () => {
    dispatch(resetUserManagementFilters({}));

    setSearchTerm(null);
    setCarrierId(null);
    setSelectedUserType(null);
  };

  const handleSearchButtonClick = () => {
    dispatch(
      updateUserManagementFilters({
        filters: {
          ...filters,
          searchTerm: searchTerm,
          roleId: selectedUserType,
          carrierId: carrierId,
        },
      })
    );
  };

  return (
    <StyledWrapperGridItem item theme={theme} xs={12}>
      <Grid container alignItems="center" spacing={2}>
        <StyledFilterGridItem item>
          <StyledGridHeaderItem item component="h5">
            Search for a user:
          </StyledGridHeaderItem>
        </StyledFilterGridItem>
        <StyledFilterGridItem item>
          <StyledTextField
            value={searchTerm ?? ""}
            onChange={(event) => setSearchTerm(event.target.value)}
            variant="outlined"
            label="First name, Last name or Email"
            disabled={false}
            style={{ width: "230px" }}
            inputProps={{
              "data-testid": "user-search-textfield",
              maxLength: 256,
            }}
          />
        </StyledFilterGridItem>
        <StyledFilterGridItem item>
          <UserTypeFilter
            setSelectedUserType={setSelectedUserType}
            selectedUserType={selectedUserType}
          />
        </StyledFilterGridItem>
        <StyledFilterGridItem item>
          <CarrierFilter
            carrierId={carrierId}
            setCarrierId={setCarrierId}
            width={230}
          />
        </StyledFilterGridItem>
        <StyledFilterGridItem item>
          <BaseButton
            onClick={handleSearchButtonClick}
            data-testid="user-mgmt-search-btn"
          >
            Search
          </BaseButton>
        </StyledFilterGridItem>
        <StyledFilterGridItem item>
          <StyledButton
            theme={theme}
            onClick={handleResetFilters}
            data-testid="clear-search-user-mgmt"
          >
            Clear Search
          </StyledButton>
        </StyledFilterGridItem>
      </Grid>
    </StyledWrapperGridItem>
  );
};

export default UserManagementFiltersContainer;
